// VAT rates by destination country.
// Values are decimal rates (e.g. 0.25 = 25%).
export const DEFAULT_VAT_RATE = 0.25;

const VAT_BY_COUNTRY = {
    DK: 0.25,
    DENMARK: 0.25,
    DANMARK: 0.25,

    NO: 0.25,
    NORWAY: 0.25,
    NORGE: 0.25,

    SE: 0.25,
    SWEDEN: 0.25,
    SVERIGE: 0.25,

    DE: 0.19,
    GERMANY: 0.19,
    DEUTSCHLAND: 0.19,

    NL: 0.21,
    NETHERLANDS: 0.21,

    BE: 0.21,
    BELGIUM: 0.21,

    FR: 0.20,
    FRANCE: 0.20,

    ES: 0.21,
    SPAIN: 0.21,

    IT: 0.22,
    ITALY: 0.22,

    FI: 0.255,
    FINLAND: 0.255,

    GB: 0.20,
    UK: 0.20,
    'UNITED KINGDOM': 0.20,
};

function normalizeCountry(country) {
    return String(country || '').trim().toUpperCase();
}

export function getVatRateByCountry(country) {
    const key = normalizeCountry(country);
    return VAT_BY_COUNTRY[key] ?? DEFAULT_VAT_RATE;
}
